import { render, staticRenderFns } from "./phoneRecords.vue?vue&type=template&id=c289c61c&scoped=true&"
import script from "./phoneRecords.vue?vue&type=script&lang=js&"
export * from "./phoneRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c289c61c",
  null
  
)

export default component.exports